/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeTree, setField, DEFAULT_SAVED_SEARCH_TREE_SORT } from '../helpers/savedSearches';

export const favorite = createAsyncThunk(
  'savedSearches/favorite',
  async (
    {
      _id, name, value, showToast = true,
    },
    {
      extra: {
        sdk, Logger, Toast, localization: l18n,
      },
      getState, dispatch,
    },
  ) => {
    const userId = getState().user._id;
    try {
      await sdk.savedSearches.favorite(_id, value);

      if (showToast) {
        Toast(l18n.TOAST.SAVED_SEARCHES_FAVORITE(name, value), {
          type: 'success',
          btnOkValue: l18n.textBtnUndo,
          onOk: () => dispatch(favorite({
            _id, name, value: !value, showToast: false,
          })),
        });
      }
      return { _id, value, userId };
    } catch (error) {
      Logger.error(new Error('Can not add saved searches to favorites'), { error }, [
        'AddSavedSearchesToFavoritesFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    favorite.pending,
    (state, { meta: { arg: { _id } } }) => {
      state.tree = setField(state.tree, _id, 'isBusy', true);
    },
  ).addCase(
    favorite.fulfilled,
    (state, { payload: { _id, userId, value } }) => {
      state.all = state.all.map((ss) => {
        if (ss._id !== _id) return ss;
        return { ...ss, favorites: value ? [...(ss.favorites || []), userId] : ss.favorites.filter((id) => id !== userId) };
      });
      state.tree = makeTree(
        state.all,
        userId,
        state.searchQuery,
        state.treeSortType || DEFAULT_SAVED_SEARCH_TREE_SORT,
      );
    },
  ).addCase(
    favorite.rejected,
    (state, { error, meta: { arg: { _id } } }) => {
      state.error = error;
      state.tree = setField(state.tree, _id, 'isBusy', false);
    },
  );
};
